import PesquisaSatisfacaoService from "@/services/PesquisaSatisfacaoService";
import VendaService from "@/services/VendaService";
import store from "@/store";
import moment from "moment";
export const actions = {
  cadastrarPesquisaSatisfacao: ({ commit, dispatch }) => {
    commit("setPesquisaSatisfacao", {
      id: "",
      venda_id: "",
      check_list_produtos: "",
      avaliacao_atendimento: "",
      avaliacao_caixa: "",
      avaliacao_produtos: "",
      avaliacao_servicos: "",
      path_documento: "",
      como_conheceu: "",
      indicaria_servicos: "",
      conhece_midias_sociais: "",
      midia_mais_usada: "",
    }),
      dispatch("setModalCadastroPesquisaSatisfacao", true);
  },
  listarPesquisaSatisfacao: ({ commit }, data) => {
    commit("setOverlay", true);
    PesquisaSatisfacaoService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setPesquisasSatisfacao", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  async visualizarPesquisaSatisfacao({ commit, dispatch }, data) {
    commit("setPesquisaSatisfacao", { ...data });
    commit("setModalCadastroPesquisaSatisfacao", true);
  },
  salvarPesquisaSatisfacao: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PesquisaSatisfacaoService.salvar(data)
      .then((res) => {
        // commit('addPesquisaSatisfacao', res.data)
        commit("setPesquisaSatisfacao", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Pesquisa salva.");
        dispatch("listarPesquisaSatisfacao", {});
        dispatch("setModalCadastroPesquisaSatisfacao", false);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarPesquisaSatisfacao: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PesquisaSatisfacaoService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Pesquisa atualizada.");
        commit("setPesquisaSatisfacao", { ...store.getters.getPesquisaSatisfacao, ...res.data });
        dispatch("listarPesquisaSatisfacao", {});
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirPesquisaSatisfacao: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirPesquisaSatisfacao", false);
    dispatch("setModalCadastroPesquisaSatisfacao", false);
    PesquisaSatisfacaoService.excluir(data.id)
      .then((res) => {
        dispatch("setModalVisualizarPesquisaSatisfacao", false);
        dispatch("listarPesquisaSatisfacao", {});
        commit("setOverlay", false);
        commit("snackbarError", "Pesquisa excluída.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir pesquisa.");
      });
  },
  async gerarFormularioPesquisaSatisfacao({ commit, dispatch }, data) {
    commit("setOverlay", true);
    await PesquisaSatisfacaoService.gerarFormulario(data)
      .then((res) => {
        console.log(res.data);
        commit("setOverlay", false);
        commit("setFormularioPesquisaSatisfacao", res.data);
        commit("snackbarSuccess", "Formulário gerado com sucesso.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao gerar formulário.");
      });
  },
  setModalCadastroPesquisaSatisfacao: ({ commit }, status) => {
    commit("setModalCadastroPesquisaSatisfacao", false);
    setTimeout(() => {
      commit("setModalCadastroPesquisaSatisfacao", status);
    }, 100);
  },
  setModalVisualizarPesquisaSatisfacao: ({ commit }, status) => {
    commit("setModalVisualizarPesquisaSatisfacao", false);
    setTimeout(() => {
      commit("setModalVisualizarPesquisaSatisfacao", status);
    }, 100);
  },
  setModalAtualizarTabelaPesquisaSatisfacao: ({ commit }, status) => {
    commit("setModalAtualizarTabelaPesquisaSatisfacao", false);
    setTimeout(() => {
      commit("setModalAtualizarTabelaPesquisaSatisfacao", status);
    }, 100);
  },
  setModalExcluirPesquisaSatisfacao: ({ commit }, status) => {
    commit("setModalExcluirPesquisaSatisfacao", false);
    setTimeout(() => {
      commit("setModalExcluirPesquisaSatisfacao", status);
    }, 100);
  },
};

export default {};
